import React from 'react';

import './style.scss';

const Error = props => {
	return <div className="home">Page not found. Error 404</div>;
};

export default Error;
